module.exports = __webpack_public_path__ + "img/copy.c64d97c9.svg";